import styles from './FormErrorBanner.module.scss'

import { c } from '@/utils'

interface FormErrorBannerProps {
  message: string
  className?: string
}

/**
 * Inline form-level error banner. Persistent (no auto-dismiss timeout) so it
 * stays visible until the user fixes the underlying issue — unlike the
 * top-of-page Banner toast which clears after 10s.
 */
const FormErrorBanner = ({ message, className }: FormErrorBannerProps) => (
  <div className={c(styles.banner, className)} role="alert">
    {message}
  </div>
)

export default FormErrorBanner
